import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function CTABand() {
  return <section className="py-24 bg-atomic-charcoal border-t border-white/10 relative overflow-hidden" data-id="element-17">
      {/* Abstract Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-atomic-green/5 to-transparent" data-id="element-18"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-r from-atomic-black/50 to-transparent" data-id="element-19"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-20">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10" data-id="element-21">
          <div className="text-center lg:text-left max-w-2xl" data-id="element-22">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-23">
              Ready to <span className="text-atomic-green" data-id="element-24">Print?</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-xl text-gray-300" data-id="element-25">
              Join thousands of brands and businesses trusting Print Atomic with
              their production. Fast quotes, fair prices, atomic quality.
            </motion.p>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto" data-id="element-26">
            <Button size="lg" className="w-full sm:w-auto text-lg px-10" data-id="element-27">
              Get a Quote
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto text-lg px-10" data-id="element-28">
              Contact Us
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}